import React from 'react';
import { Controller } from 'react-hook-form';

import { type InputTextProps } from '@companycam/slab-web';

import { StyledInput } from '../CommonComponents';
import { UseProfileFormReturn } from '../useProfileForm';

type TextFieldProps = Omit<InputTextProps, 'id' | 'onChange' | 'value'> & {
  name:
    | 'name'
    | 'addressLine1'
    | 'addressLine2'
    | 'city'
    | 'postalCode'
    | 'phoneNumber'
    | 'email'
    | 'website';
  formMethods: UseProfileFormReturn;
  label: InputTextProps['label'];
  placeholder: InputTextProps['placeholder'];
  'data-testid'?: string;
  onChange?: (value: string) => void;
};

export const TextField = ({
  name,
  label,
  placeholder,
  formMethods,
  'data-testid': dataTestId,
  onChange,
  ...rest
}: TextFieldProps) => {
  return (
    <Controller
      name={name}
      control={formMethods.control}
      render={({ field }) => (
        <StyledInput
          testId={dataTestId}
          label={label}
          placeholder={placeholder}
          id={name}
          onChange={(e) => {
            field.onChange(e);
            if (onChange) {
              onChange(e.target.value);
            }
          }}
          value={field.value}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
        />
      )}
    />
  );
};
